import { createStore } from 'effector';
import { createEffectJWT } from '../JWT';
import { getPermissions, RPermissions } from '../../apiRPC/account';

export const getPermissionsFx = createEffectJWT(getPermissions, 'getPermissionsFx');

export const $permissions = createStore<RPermissions | null>(null).on(
  getPermissionsFx.doneData,
  (_, payload) => payload,
);


